
import { VehicleValidation, VehicleValidationStatus } from '../models/vehicle-validation';
import { FleetChecklistType } from "../models/fleet-checklist";


export class VehicleValidationHelper {

  static getValidationStatusByVehicle(vehicle: VehicleValidation): VehicleValidationStatus {
    const criteria = vehicle.criteria;

    const requiredCriteria = ['11', '12', '13']; // GPS, CIPIA, CÁMARAS

    const hasReview = requiredCriteria.some(
      id => criteria[id]?.selectedStateId == '11'
    );


    const hasObs = requiredCriteria.some(
      id => criteria[id]?.selectedStateId == '8'
    );

    return hasReview
      ? VehicleValidationStatus.inReview
      : hasObs ? VehicleValidationStatus.observation : VehicleValidationStatus.completed;
  }



  static isVehicleComplete(
    vehicle: VehicleValidation,
    typeValidation?: string
  ): boolean {
    const criteriaValid = Object.values(vehicle.criteria).every(
      criterion =>
        criterion.selectedStateId !== null &&
        criterion.selectedStateId !== undefined &&
        criterion.selectedStateId !== ''
    );

    if (
      typeValidation == FleetChecklistType.EXTERNO ||
      typeValidation == FleetChecklistType.INTERNO
    ) {
      const fieldsValid = Object.entries(vehicle.fields)
        .filter(
          ([key]) =>
            key !== 'validada' &&
            key !== 'programada' &&
            key !== 'ruta'
        )
        .every(
          ([, field]) =>
            field.value !== null &&
            field.value !== undefined &&
            field.value !== ''
        );

      return criteriaValid && fieldsValid;
    }

    return criteriaValid;
  }

}
